import React from "react"

const AppBlock = () => {
  return (
    <>
      <section className="pt-5 pb-0 bg-light">
        <div className="container">
          <div className="row application-st">
            <div className="col-12 col-lg-8">
              <div className="slide-content pb-5">
                <div className="header-text-app">
                  <h4 className="component-title-applicaton text-dark-blue">
                    Download iOS &amp; Android app
                  </h4>
                  <p className="description-applicaton">
                    Let's be Appy&#128521; You can now manage your hosting and
                    domains on the move. Yes! You may download Motherhost
                    Application from Apple Store or Google Play store. You can
                    Register, Renew and Host your domain name from anywhere, any
                    time.
                  </p>
                </div>
                <ul className=" legal d-flex mt-3">
                  <li>
                    <a
                      href="https://apps.apple.com/us/app/motherhost/id1577482366"
                      className="p-0 me-3 "
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src="/img/App-Store-iOS-Badge-Logo.png"
                        alt="motherhost ios app"
                        className="app-icon" width="139" height="48"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.motherhost.webhosting"
                      className="p-0 "
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src="/img/Google-Play-Badge-Logo.png"
                        alt="motherhost android app"
                        className="app-icon" width="159" height="48"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-lg-4 ">
              <div className="app-screen-block d-none d-lg-block ">
                <img
                  src="/img/motherhost-app-screen.webp"
                  alt="motherhost app screen"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AppBlock
